
export const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};


export const validateEmailForm = (data) => {
    const errors = {
        subject: '',
        body: ''
    };

    // Validate subject
    if (!data.subject || data.subject.trim() === '') {
        errors.subject = 'Subject is required';
    } else if (data.subject.trim().length < 5) {
        errors.subject = 'Subject must be at least 5 characters';
    } else if (data.subject.length > 200) {
        errors.subject = 'Subject must not exceed 200 characters';
    }

    // Validate body
    if (!data.body || data.body.trim() === '') {
        errors.body = 'Message body is required';
    } else if (data.body.trim().length < 10) {
        errors.body = 'Message body must be at least 10 characters';
    } else if (data.body.length > 5000) {
        errors.body = 'Message body must not exceed 5000 characters';
    }

    return errors;
};

export const hasValidationErrors = (errors) => {
    return Object.values(errors).some(error => error !== '');
};
